export const defaultGaugeSeriesOptions = Object.freeze({
  showInLegend: true,
  dataLabels: {
    enabled: true,
    borderWidth: 0,
    useHTML: true,
    style: {
      fontSize: '16px'
    }
  },
  dial: {
    radius: '105%',
    rearLength: '-70%',
    baseWidth: 3,
    topWidth: 3,
    borderWidth: 0
  },
  pivot: {
    radius: 0
  }
});